import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRankRocketSilver = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1786 2.04984C14.861 0.827552 17.139 0.827554 18.8214 2.04984L28.3955 9.00588C30.0779 10.2282 30.7818 12.3947 30.1392 14.3724L26.4822 25.6276C25.8396 27.6053 23.9966 28.9443 21.9172 28.9443H10.0828C8.00335 28.9443 6.16037 27.6053 5.51777 25.6276L1.86076 14.3724C1.21817 12.3947 1.92213 10.2282 3.60447 9.00588L13.1786 2.04984Z",
			fill: "#C9C9C9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2343 18.6767C13.7506 18.2932 13.3123 17.8549 12.9288 17.3712C12.9389 17.3155 12.9495 17.26 12.9608 17.2047C13.1935 16.0584 13.6712 15.0011 14.337 14.0899C15.7921 12.0985 18.1452 10.8048 20.8004 10.8047C20.8004 13.46 19.5067 15.8133 17.5153 17.2685C16.6041 17.9343 15.5467 18.4122 14.4004 18.6449C14.3452 18.6561 14.2899 18.6667 14.2343 18.6767Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6004 14.0047C11.8331 14.0047 10.4004 15.4374 10.4004 17.2047H12.9608C13.1935 16.0584 13.6712 15.0011 14.337 14.0899C14.1005 14.0342 13.8539 14.0047 13.6004 14.0047Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4004 21.2047C16.1677 21.2047 17.6004 19.772 17.6004 18.0047C17.6004 17.7513 17.5709 17.5048 17.5153 17.2685C16.6041 17.9343 15.5467 18.4122 14.4004 18.6449V21.2047Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5153 17.2685C17.5709 17.5048 17.6004 17.7513 17.6004 18.0047C17.6004 19.772 16.1677 21.2047 14.4004 21.2047V18.6449M17.5153 17.2685C19.5067 15.8133 20.8004 13.46 20.8004 10.8047C18.1452 10.8048 15.7921 12.0985 14.337 14.0899M17.5153 17.2685C16.6041 17.9343 15.5467 18.4122 14.4004 18.6449M14.337 14.0899C14.1005 14.0342 13.8539 14.0047 13.6004 14.0047C11.8331 14.0047 10.4004 15.4374 10.4004 17.2047H12.9608M14.337 14.0899C13.6712 15.0011 13.1935 16.0584 12.9608 17.2047M14.4004 18.6449C14.3452 18.6561 14.2899 18.6667 14.2343 18.6767C13.7506 18.2932 13.3123 17.8549 12.9288 17.3712C12.9389 17.3155 12.9495 17.26 12.9608 17.2047M11.7667 18.4798C11.1802 18.9173 10.8004 19.6166 10.8004 20.4047C10.8004 20.531 10.8102 20.6551 10.829 20.7761C10.95 20.7949 11.0741 20.8047 11.2004 20.8047C11.9884 20.8047 12.6878 20.4249 13.1253 19.8383",
			stroke: "white",
			strokeWidth: .8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0004 14.4016C18.0004 14.8434 17.6422 15.2016 17.2004 15.2016C16.7586 15.2016 16.4004 14.8434 16.4004 14.4016C16.4004 13.9597 16.7586 13.6016 17.2004 13.6016C17.6422 13.6016 18.0004 13.9597 18.0004 14.4016Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRankRocketSilver;
